<template>
  <v-layout
    row
    pb-2>
    <v-flex
      xs12
      md8
      offset-md2
      lg6
      offset-lg3>
      <v-card class="card--flex-toolbar">
        <app-secondary-toolbar
          :action="{ name: 'productDetail', params: { id: 'new' } }"
          :back-link="'categoryList'"
          :title="categoryTitle" />
        <v-divider />
        <v-card-text>
          <v-list
            two-line
            subheader>
            <v-list-tile
              v-for="(product) in category.products"
              :key="product._id"
              :to="{ name: 'productDetail', params: { id: product._id } }">
              <v-list-tile-content>
                <v-list-tile-title>{{ product.name }} ({{ product.reference }})</v-list-tile-title>
                <v-list-tile-sub-title v-if="product.description">
                  {{ product.description[0].text }}
                </v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
        </v-card-text>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import axios from "@/axios-auth";
import appSecondaryToolbar from "@/components/TheSecondaryToolbar";

export default {
  name: "ProductList",
  components: {
    appSecondaryToolbar
  },
  props: {
    categoryId: {
      type: String,
      required: true
    }
  },
  data: () => ({
    category: {}
  }),
  computed: {
    categoryTitle() {
      if (this.category.title) return this.category.title[0].text;
      return "";
    }
  },
  created() {
    this.fetchProducts();
  },
  methods: {
    fetchProducts() {
      axios.get(`/categories/${this.categoryId}/products`, { headers: { "x-locale": "nl-be" } })
        .then((response) => {
          this.category = response.data.category;
        });
    }
  }
};
</script>
